<mat-sidenav-container>
  <mat-sidenav #rightSideNav2 mode="over" position="end" disableClose>
    <router-outlet name="sb2"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-sidenav-container>
      <mat-sidenav #rightSideNav mode="over" position="end" disableClose [ngClass]="matSidenavClasses">
        <router-outlet name="sb"></router-outlet>
      </mat-sidenav>
      <mat-sidenav-content>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-sidenav-content>
</mat-sidenav-container>
